import { useState } from "react";

export default function useToken() {
  const getToken = () => {
    // const tokenString = sessionStorage.getItem("token");
    const tokenString = localStorage.getItem("token");
    // const userToken = JSON.parse(tokenString);
    return tokenString;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (token) => {
    // sessionStorage.setItem("token", JSON.stringify(userToken));
    localStorage.setItem("token", token);
    setToken(token);
  };

  // ====================

  const getAuth = () => {
    const authString = localStorage.getItem("auth");
    const userAuth = JSON.parse(authString);
    return userAuth?.token;
  };

  const [auth, setAuth] = useState(getAuth());

  const saveAuth = (userAuth) => {
    localStorage.setItem("auth", JSON.stringify(userAuth));
    setAuth(userAuth.userid);
  };

  return {
    auth,
    setAuth: saveAuth,
    token,
    setToken: saveToken,
  };
}
